import React, {useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {SwiperWindowComponent} from "../orbit-swiper/swiper-window.component";
import {useServices} from "../../react-hooks/use-services.hook";
import {reaction} from "mobx";
import {CyClass} from "../../../common/cy-classes";
import useIsInViewPort from "../../react-hooks/use-is-in-viewport.hook";

interface ArenaGamesListsComponentProps {
    arenaName: string;
}

export const ArenaGamesListsComponent: React.FC<ArenaGamesListsComponentProps> = observer((props) => {
    const services = useServices();
    const [listsCount, setListsCount] = useState(0);
    const [hasMoreLists, setHasMoreLists] = useState(true);
    const intersectionSpyRef = useRef<HTMLDivElement | null>(null);
    let isIntersectionSpyInViewport = useIsInViewPort(intersectionSpyRef);

    const arena = services.arenas.getArena(props.arenaName);

    const loadNextBatch = () => {
        const nextBatch = arena.getNextBatchSize(listsCount);
        if(nextBatch === 0) {
            if(hasMoreLists !== false) {
                setHasMoreLists(false);
            }
        } else {
            setListsCount(listsCount + nextBatch);
        }
    }

    useEffect(() => {
        const reactionDispose = reaction(() => services.user.isAuthorized,
            () => {
                setListsCount(0);
                setHasMoreLists(true);
            });

        return () => {
            reactionDispose();
        }
    }, [services.user.isAuthorized]);

    useEffect(() => {

        const spyRectangle = intersectionSpyRef.current.getBoundingClientRect();
        //spyRectangle.top <= window.innerHeight is here because IntersectionObserver used by useIsInViewPort hook has a delay in detecting that the element is not in the viewport anymore.
        if(spyRectangle.top <= window.innerHeight && hasMoreLists && isIntersectionSpyInViewport) {
            loadNextBatch();
        }
    });




    const range = Array.from({length: listsCount}, (x, i) => i + 1);

    return (

        <React.Fragment key={`${props.arenaName}_LISTS`}>
            {range.map(listWindowPosition => (<SwiperWindowComponent key={listWindowPosition}
                                                                     windowPosition={listWindowPosition}
                                                                     arena={arena}/>))}

            <div style={{ width: "100%", height: "1px"}}
                 ref={intersectionSpyRef}
                 className={CyClass('cy-lists-intersection-observer-target')}/>
        </React.Fragment>
    );

});

